<template>
  <div id="app" class="layout-body">
    <!-- 导航部分 -->
    <header v-if="isNavMode">
      <HeaderBox/>
      <!-- 注册/登录 start -->
      <!-- <div class="login">
        <a @click="doLogin('/login')">登录</a>
        <a>注册</a>
      </div> -->
      <!-- 注册/登录 end -->
    </header>
    <!-- 主内容  -->
    <main>
      <router-view />
    </main>
    <!-- 底部内容  -->
    <footer v-if="isNavMode">
      <FooterBox />
    </footer>
  </div>
</template>

<script>
import HeaderBox from "./components/HeaderBox.vue"
import FooterBox from "./components/FooterBox.vue"
export default {
  name: 'App', 
  components: {HeaderBox,FooterBox},
  data () {
    return {
      isNavMode: true
    }
  },
  watch:{
    // 监听路由变化
    "$route.path":function(newVal,oldVal){
      if(newVal.indexOf('login')!= -1 || newVal.indexOf('website')!= -1 || newVal.indexOf('dashboard')!= -1 || newVal.indexOf('share')!= -1 || newVal.indexOf('404')!= -1){
        this.isNavMode=false
      } else{
        this.isNavMode=true
      }
    }
  },
  methods:{
    // 登录
    doLogin(url){ 
      this.isNavMode= false;
      this.$router.push({ path: url })
    } 
  }
}

</script>

<style lang="scss">   
#app {
  font-family: "Source Han Sans CN-Regular", "Source Han Sans CN", "Source Han Sans", "Microsoft YaHei", "PingFang SC", "Lantinghei SC", "HanHei SC", "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", 微软雅黑, STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
}
.layout-body{  
  width: 100%;
  min-width: $width-content;
}
header{ 
  position: fixed;
  display: flex;
  height: 70px;
  width: 100%;
  top: 0px;
  z-index: 88;
  border-bottom: 1px solid rgba(255,255,255 ,0.22);
  background: rgba(0,0,0,0.7);
  // box-shadow:  0px 0px 7px rgba(204,204,204,0.6);
  .login{
    position: absolute;
    display: flex;
    height: 70px;
    right: 0px;
    top: 0px;
    width: 200px;
    a{
      width: 0px;
      flex-grow: 1;
      line-height: 70px;
      text-align: center;
      font-size: $sub-size;
      &:first-child{
        color:#fff;
      }
      &:last-child{
        background: $primary-color;
        color:#fff;
      }
    }
  }

}
main{
  width: 100%; 
}
footer{
  width: 100%;
  height: 480px;
  background: #242e49 url('./assets/images/bg-settled.png') no-repeat center top;
  background-size: 100% 0px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue